<template>
    <v-app>
        <v-main v-resize="setWindow" style="background-color: #f8f9fe">
        <div>

            <!--Content-->
            <v-container class="d-flex align-center" style="height: 100vh">
                <router-view></router-view>
            </v-container>

            <!--Alert-->
			<alert></alert>
        </div>
    </v-main>
    </v-app>
</template>
<script>

import Alert from "../../components/EvAlert.vue";

export default {
    name: 'AuthApp',
	components: {Alert},
	methods: {
		setWindow() {
			this.$store.commit('screen/setWindow')
		}
	},
}
</script>
